import React, {useMemo} from 'react'
import {cloneDeep} from 'lodash-es'
import {GameValidator} from '@colonist/game-mechanic-validators'
import {UIGameLog} from './UIGameLog/UIGameLog.tsx'
import {UIGameChat} from './UIGameChat/UIGameChat.tsx'
import {useGameStore} from '../../store/GameStoreContext.ts'

export type UIGameFeedsPortraitVisibility = 'log' | 'chat' | 'none'

interface UIGameFeedsPortraitProps {
    visibility: UIGameFeedsPortraitVisibility
    onClickLog: (logIndex: number) => void
    onSendChat: (msg: string) => void
}

export const UIGameFeedsPortrait = ({
    visibility,
    onClickLog,
    onSendChat,
}: UIGameFeedsPortraitProps) => {
    const gameState = useGameStore((state) => state.gameState)
    const userStates = useGameStore((state) => state.gameUserStates.userStates)

    const gameValidator = useMemo(() => {
        const clonedGameState = cloneDeep(gameState)
        for(const playerColorKey in clonedGameState.playerStates) {
            clonedGameState.playerStates[playerColorKey].isConnected = true
        }

        return new GameValidator(gameState, userStates)
    }, [])

    return (
        <>
            <UIGameLog
                isLogVisible={visibility === 'log'}
                gameValidator={gameValidator}
                backgroundColor="blue"
                onClickLog={onClickLog}
            />
            <UIGameChat
                isChatVisible={visibility === 'chat'}
                onSendChat={onSendChat}
                gameValidator={gameValidator}
                backgroundColor="blue"
                isMinimizeable={false}
            />
        </>
    )
}
